import { breakpoints } from '@Front/constants';

export default class ProductDetails {
  constructor(container) {
    this.container = container;
    this.topElement = container.querySelector(
      '.floating-elements__sticky-mobile-buttons',
    );
  }

  topEdgePosition() {
    return this.topElement.getBoundingClientRect().height;
  }

  attachListeners() {
    window
      .matchMedia(`(max-width: ${breakpoints['break-2']}px)`)
      .addEventListener('change', (e) => {
        this.topElement.dataset.small = e.matches;
      });
  }

  mount() {
    this.attachListeners();
    return this;
  }
}
